import type { WorkflowFilterStatus } from '@app/shared/types/sf-data'

import { SfLog } from '@app/adapters/logger'
import SFetch from '@app/utils/sfetch'

export async function persistOverviewFilter(
  filter: WorkflowFilterStatus
): Promise<void | null> {
  const url = window.Silverfin.Routes.persist_overview_filter_users_path(
    window.Silverfin.currentFirmId,
    {
      company_id: window.Silverfin.currentCompanyId,
      filter,
    }
  )

  try {
    await SFetch.json(url, { method: 'POST' })
  } catch (e) {
    SfLog.warn('Cannot persist overview filter', {
      extra: { error: e, filter },
    })
  }
}
